// Temporary test dataset for the 4-track album mixer.
export const albumMixerSongs = [
  {
    id: "nirfana",
    title: "Nirfana",
    side: "A",
    sideIndex: 1,
    tracks: [
      {
        id: "drums",
        title: "Drums",
        url: "https://www.dropbox.com/scl/fi/yduulz1htfnrt83489han/DRUMS.mp3?rlkey=cj7dc0zomfbbf0nhws2cumc5p&st=j3l9u8zc&dl=0",
      },
      {
        id: "bass",
        title: "Bass",
        url: "https://www.dropbox.com/scl/fi/ui5v0jhc8yl4phmtxis5f/BASS.mp3?rlkey=zq7xrfa4ed85vsvncyjmjsurp&st=mkqcpfdu&dl=0",
      },
      {
        id: "acoustic",
        title: "Acoustic",
        url: "https://www.dropbox.com/scl/fi/zk9vh0ics17qv8j3my9z1/ACOUSTIC.mp3?rlkey=2ium0dwofahw0f2do6j92v4cc&st=xz6di70x&dl=0",
      },
      {
        id: "vox",
        title: "Vox",
        url: "https://www.dropbox.com/scl/fi/vdn7gmdo3gk9opmxysa0s/VOX.mp3?rlkey=kofora60lom2115mzq3pm0n7j&st=b4mgcqlg&dl=0",
      },
    ],
  },
  {
    id: "nafir",
    title: "Nafir",
    side: "B",
    sideIndex: 1,
    tracks: [
      {
        id: "drums",
        title: "Drums",
        url: "https://www.dropbox.com/scl/fi/lyylypc18fwshc0tkp49n/DRUMS.mp3?rlkey=2t5j2odn0c6m14011diho2h12&st=dvh4d0ha&dl=0",
      },
      {
        id: "bass",
        title: "Bass",
        url: "https://www.dropbox.com/scl/fi/miad4wkhb4z1bvwpj9m6a/BASS.mp3?rlkey=ndycs97q9gpb542b6371lpbrp&st=kgsburf3&dl=0",
      },
      {
        id: "acoustic",
        title: "Acoustic",
        url: "https://www.dropbox.com/scl/fi/hpmxzk21dv7gt3xnhglb6/ACOUSTIC.mp3?rlkey=foazaq3zq74l9usyhib8j3gl6&st=bkvrbkrb&dl=0",
      },
      {
        id: "vox",
        title: "Vox",
        url: "https://www.dropbox.com/scl/fi/49yxujurw5h0ioedu7mub/VOX.mp3?rlkey=2ekcx6mlcvmryl8um9o4t5qel&st=y53fztm6&dl=0",
      },
    ],
  },
  {
    id: "jafnari",
    title: "Jafnari",
    side: "A",
    sideIndex: 2,
    tracks: [
      {
        id: "drums",
        title: "Drums",
        url: "https://www.dropbox.com/scl/fi/5znafvauv7ucjfyy0izzj/DRUMS.mp3?rlkey=sads5qwwad4xd43ur2zzjlx1o&st=cont2l9u&dl=0",
      },
      {
        id: "bass",
        title: "Bass",
        url: "https://www.dropbox.com/scl/fi/xtsnw0pgqsutmwhw01441/BASS.mp3?rlkey=5k3zzurlkpdqmspe2x630kkdg&st=9bmrtn1q&dl=0",
      },
      {
        id: "acoustic",
        title: "Acoustic",
        url: "https://www.dropbox.com/scl/fi/rsva2x0bvsgy4tq8nxlt9/ACOUSTIC.mp3?rlkey=8eirgrsylrmlqg5e215gqq1eh&st=dpo8web2&dl=0",
      },
      {
        id: "vox",
        title: "Vox",
        url: "https://www.dropbox.com/scl/fi/58l9hy4fjq2z37ypsoz7y/VOX.mp3?rlkey=6ihb8h7n820pn3s0iike9pnk5&st=d3l0cw2u&dl=0",
      },
    ],
  },
  {
    id: "djakninn",
    title: "Djakninn",
    side: "B",
    sideIndex: 2,
    tracks: [
      {
        id: "drums",
        title: "Drums",
        url: "https://www.dropbox.com/scl/fi/ohf4rxbopfmjr8yyopw3q/DRUMS.mp3?rlkey=thzzy8fp4bddbwa4fw6jm21hl&st=t3firw7e&dl=0",
      },
      {
        id: "bass",
        title: "Bass",
        url: "https://www.dropbox.com/scl/fi/4tj2yh8i2ic12ko32hwwd/BASS.mp3?rlkey=zu18mtb7wtld0nch2qrhcca14&st=r0usvmgi&dl=0",
      },
      {
        id: "acoustic",
        title: "Acoustic",
        url: "https://www.dropbox.com/scl/fi/ogs2yp4djqro63ne3r98f/ACOUSTIC.mp3?rlkey=yvxxg5sm4o8mfmrqy7pvvyt5z&st=qrkyr8er&dl=0",
      },
      {
        id: "vox",
        title: "Vox",
        url: "https://www.dropbox.com/scl/fi/rn0bjv2n6wjxhg8tl906e/VOX.mp3?rlkey=u7skphgp0vvnqwus1o25lfxa4&st=owxvg3ss&dl=0",
      },
    ],
  },
];
